import styled from "styled-components";
import { TimerControllerBackgroundBox } from "../../../style";

export const ControllerSkinSelectorWrapper = styled.div`
  display: flex;
  gap: 12px;
  overflow: hidden;
  width: 100%;
  max-width: 1587px;
  min-width: 0;
`;

export const ControllerSkinSelectorLeftWrapper = styled(
  TimerControllerBackgroundBox,
)`
  display: flex;
  gap: 18px;
  flex-direction: column;
  position: relative;
  padding: 40px 27px 18px 30px;
  background-color: #2e2e2e;
`;

export const ControllerSkinSelectorRightWrapper = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;
`;

export const ControllerSkinSelectorHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const ControllerSkinSelectorSubPrizeFontWrapper = styled.div`
  color: #fff;
  text-align: right;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  display: flex;
  align-items: center;
  gap: 10px;

  > img {
    cursor: pointer;
  }
`;

export const ControllerSkinSelectorImageWrapper = styled.div<{
  isHorizontal: boolean;
}>`
  display: flex;
  gap: 14px;
  align-items: flex-start;

  > img {
    flex: 1;
    width: 100%;
    height: auto;
    max-width: ${(p) => (p.isHorizontal ? "566px" : "272px")};
    max-height: ${(p) => (p.isHorizontal ? "319px" : "485px")};
    min-width: ${(p) => (p.isHorizontal ? "60%" : "0")};
  }
`;

export const ControllerSkinSelectorViewWrapper = styled.div<{
  isHorizontal: boolean;
}>`
  flex: 1;
  display: grid;
  grid-template-columns: ${(p) =>
    p.isHorizontal
      ? "repeat(2, minmax(0, 221px))"
      : "repeat(3, minmax(0, 134px))"};
  justify-content: start;
  align-content: flex-start;
  height: max-content;
  gap: ${(p) => (p.isHorizontal ? "8px" : "8px 10px")};

  > .view {
    flex-shrink: 0;
    max-width: ${(p) => (p.isHorizontal ? "221px" : "134px")};
    max-height: ${(p) => (p.isHorizontal ? "124px" : "239px")};
    height: auto;
    box-shadow: 0px 4.82px 4.82px 0px #00000040;
    position: relative;

    > img {
      width: 100%;
      height: 100%;
    }
  }
`;

export const ControllerSkinSelectorButtonWrapper = styled.div`
  position: absolute;
  background: #3052fb;
  width: 345px;
  height: 58px;
  border-radius: 20px;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 18px;
  line-height: 58px;
  text-align: center;
  color: #fff;
  bottom: 50px;
  right: 30px;
  cursor: pointer;
`;

export const ControllerSkinSelectorUploadWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 12px;
  position: relative;
`;

export const ControllerSkinSelectorOverlay = styled.div<{
  isPadding?: boolean;
}>`
  position: absolute;
  width: 100%;
  height: 100%;
  top: ${(p) => (p.isPadding ? "-15px" : 0)};
  left: ${(p) => (p.isPadding ? "-15px" : 0)};
  background: #00000080;
  border-radius: 20px;
  padding: ${(p) => (p.isPadding ? "15px" : 0)};
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Pretendard;
  font-weight: 600;
  font-size: ${(p) => (p.isPadding ? "25px" : "15px")};
  line-height: 140%;
  text-align: center;
  color: #fff;
`;

export const ControllerSkinSelectorImageBorder = styled.div<{
  width?: string;
  height?: string;
}>`
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 20px;
  background-image:
    linear-gradient(#424242ff, #424242ff),
    linear-gradient(180deg, #fff 0%, #0000003a 80%);
  background-origin: border-box;
  background-clip: content-box, border-box;
  width: ${(p) => (p.width ? p.width : "140px")};
  height: ${(p) => (p.height ? p.height : "140px")};
  box-sizing: border-box;
`;

export const ControllerSkinSelectorImageUpload = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 20px;
  background-image:
    linear-gradient(0deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05)),
    linear-gradient(0deg, rgba(92, 31, 31, 0.2), rgba(92, 31, 31, 0.2));
  background-origin: border-box;
  background-clip: content-box, border-box;

  > img {
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    object-fit: cover;
    border-radius: 16px;
  }

  > .circle {
    width: 134px;
    height: 134px;
    border-radius: 50%;
    dashes: 6, 6;
    border: 2px dashed #c6c6c6;
  }
`;

export const ControllerSkinSelectorBackgroundInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #fff;

  > .title {
    margin-top: 4px;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 18px;
  }

  > .info {
    font-family: Pretendard;
    font-weight: 300;
    font-size: 15px;
    line-height: 100%;
    text-align: center;
  }
`;

export const ControllerSkinSelectorLogoInfo = styled.div`
  > .title {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 25px;
    color: #fff;
  }

  > .info {
    margin-top: 8px;
    font-family: Pretendard;
    font-weight: 500;
    font-size: 20px;
    line-height: 100%;
    color: #c6c6c6;
  }
`;
